import { Component, inject } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { TitledContainerComponent } from '@r1-compass-library/components/titled-container/titled-container.component';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { RoutingService } from '@r1-compass-library/services/routing.service';
import { Observable } from 'rxjs';

@Component({
    selector: 'r1-compass-app-division-settings',
    imports: [TitledContainerComponent, RouterModule, AsyncPipe],
    template: `
        <r1-compass-lib-titled-container [title]="(containerTitle$ | async)!">
            <router-outlet />
        </r1-compass-lib-titled-container>
    `,
})
export class DivisionSettingsComponent {
    readonly #route = inject(ActivatedRoute);
    protected readonly routingService = inject(RoutingService);

    protected containerTitle$: Observable<string> = this.routingService.getContainerTitle(
        this.#route.data,
        'Division Settings'
    );
}
